export default "__VITE_ASSET__Bu3ff9Nw__"